// Identity pages — consumed via sharedLibraries; each app's pages/index.js
// imports from here rather than maintaining its own copy.
//
// Admin pages are NOT re-exported here (deleted 2026-08-21,
// WORKSPACE-SHELL-UNDECLARED-IMPORTS-1): a top-level re-export of a
// `@symbo-ls/workspace-shell/pages/admin/*` import is stubbed by frank at
// push time and published as `""`, which then shadowed the shell's real
// values in every consumer (FRANK-PAGES-BAG-1). The shell lazy-loads
// /admin/* from its own local source and declares itself where needed.

import { login } from './auth/login.js'
import { signin } from './auth/signin.js'
import { signup } from './auth/signup.js'
import { signupConfirmation } from './auth/signup-confirmation.js'
import { resetPassword } from './auth/reset-password.js'
import { callback as authCallback } from './auth/callback.js'
import { magicCallback } from './auth/magic-callback.js'
import { profile } from './profile.js'

export {
  login,
  signin,
  signup,
  signupConfirmation,
  resetPassword,
  authCallback,
  magicCallback,
  profile
}

// Route map for the identity domain.
export const identityRoutes = {
  '/login': login,
  '/signin': signin,
  '/signup': signup,
  '/signup-confirmation': signupConfirmation,
  '/reset-password': resetPassword,
  '/auth/callback': authCallback,
  '/github-auth-callback': authCallback,
  '/auth/magic-callback': magicCallback,
  // `/settings` is the canonical route for the signed-in user's own
  // account screen (profile fields, availability, equity, notifications,
  // sessions, danger zone). `/profile` stays as a legacy alias because
  // PersonCard, ProfileModal, admin tools still link with `?u=<email>`
  // for cross-user viewing. Public profiles live at `/user/:slug`.
  '/settings': profile,
  '/profile': profile
}
